import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { truncateText } from '../../utils/utilFun';
//images
import bikeIcon from '/assets/images/bikeIcon.png';
import carIcon from '/assets/images/carIcon.png';
import planeIcon from '/assets/images/flightIcon.png';
import trainIcon from '/assets/images/trainIcon.png';
import BusIcon from '/assets/images/busIcon.png';
import taxiIcon from '/assets/images/taxiIcon.png';
import swapIcon from '/assets/images/swapIcon.png';
import ViceversaArrow from '../../components/ViceversaArrow';
import greaterThanIcon from '../../assets/icons/greaterthan.png';
import ErrorsPopup from '../sfc/ErrorsPopup';

const expendetHeaderCSS =
  'flex smAndMd:flex-row  smAndMd:items-center flex-col lg:grow lg:items-center justify-between text-secondary-400 text-xs font-medium';
const expendedSemiHeaderCSS =
  'smAndMd:h-[30px] smAndMd:flex lg:h-[45px] lg:flex justify-center items-center lg:bg-[#EEEEEE] smAndMd:w-full w-full smAndMd:text-left lg:text-center';
const expenedParagraphFirstCSS =
  'smAndMd:grow smAndMd:border-r-2 smAndMd:border-white lg:grow md:border-r-[1.5px] lg:border-[#B3B3B3]';
const expenedParagraphSecondCSS =
  'smAndMd:h-[30px] smAndMd:flex lg:h-[45px] smAndMd:w-full smAndMd:text-left smAndMd:justify-end lg:flex justify-center items-center';

const formatDate = (date) =>
  new Date(date).toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });

const MyExpenseList = ({ id, item, isMyExpense = false }) => {
  const [expenseDataShow, setExpenseDataShow] = useState(null);
  const [isEpanded, setExpanded] = useState(false);
  const [showAccordian, setShowAccordian] = useState(null);
  const [showMissingStpfcRoutes, setShowMissingStpfcRoutes] = useState({
    openModal: false,
    routesMessge: ""
  });
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const monthId = useParams();

  const {
    // expenseDetailId,
    fromCity,
    toCity,
    total,
    status,
    activity,
    activityCode,
    activityDate,
    category,
    modeOfTransport,
    distance = 0,
    fare = 0,
    categoryName = 'Meeting',
    isModifyRoute = false,
    isHoliday = false,
    halfFullDay,
    highlightExpense,
    routesModified,
    category_Entered = 'Meeting',
    wayEntered = 'ONE-WAY',
    distanceEntered = null,
    fareEntered = null,
    allowancesEntered = null,
    otherExpenseTotal = null,
    managerRemarks = '',
    adminRemarks = '',
    finalTotal,
    meetingType = '',
    routesChanged,
    routeNotFound
  } = item;
  const isSFC = item?.highlightExpense || null;
  const isModify = item?.routesModified || null;
  //const categories=item?.category_Entered || null;

  const { isHospitalSurveyEnable } = JSON.parse(
    localStorage.getItem('userData')
  );

  const handlerSetData = (data) => {
    if (data) {
      if (
        (isHospitalSurveyEnable) &&
        (status === 'Reject' ||
          status === 'Unsubmitted' ||
          status === 'Submitted')
      ) {
        if(routeNotFound) {
          setShowMissingStpfcRoutes(() => ({openModal: true, routesMessge: data?.missingRoutes }))
          return
        }
        const { activityDateFormat, expenseId, expenseDetailId } = data;
        if(monthId && location?.state?.fromHomePage) {
          navigate(`/expense-creation/${expenseDetailId}`, {
          state: {
            activityDateFor: activityDateFormat,
            expenseIdFor: expenseId,
            expenseDetailIdFor: expenseDetailId,
          },
        });
        return;
        }
        navigate('/expense-creation', {
          state: {
            activityDateFor: activityDateFormat,
            expenseIdFor: expenseId,
            expenseDetailIdFor: expenseDetailId,
          },
        });
      } else if (!isHospitalSurveyEnable) {
        const { activityDateFormat, expenseId, expenseDetailId } = data;

        localStorage.setItem(
          'SelectedExpenseData',
          JSON.stringify({
            activityDate: activityDateFormat,
            expenseId,
            expenseDetailId,
            from: 'myExpenseList',
            activitywork: activity,
            halfFull: halfFullDay,
            isModifyRoute: routesModified,
          })
        );
        // dispatch(setSelectedExpense(data));
        if(monthId && location?.state?.fromHomePage) {
          navigate(`/my-expense-details/${expenseDetailId}`, {
            state: {
              fromHomePage: location?.state?.fromHomePage
            }
          });
          return;
        }
        navigate('/my-expense-details');
      }
    }
  };
  const categories =
    JSON.parse(localStorage.getItem('SelectedExpenseData'))?.isModifyRoute ||
    null;

  const handlerClicked = (data) => {
    if(activityCode !== "SO") {
    isMyExpense && handlerSetData(data);
    if (!isMyExpense) {
      setExpanded(!isEpanded);
      setExpenseDataShow(data);
    }
  }
  return
  };

  const dividerClass = 'divider-y h-[1px] lg:h-[0] w-full bg-line-color';

  const transportIcons = {
    '2 Wheeler': bikeIcon,
    'Bike': bikeIcon,
    'Train': trainIcon,
    'Bus': BusIcon,
    'Flight': planeIcon,
    'Taxi': taxiIcon,
    'Car': carIcon,
  };

  const getTransportTypeIcons = (transport) => {
    const icon = transportIcons[transport]
    return (
      icon ? <img src={icon} alt={`${transport} icon`} width="16px" height="16px" /> : ""
    );
  };

  useEffect(() => {
    localStorage.removeItem('expenseIdCreated');
  }, []);

  return (
    <>
    <ErrorsPopup
        show={showMissingStpfcRoutes?.openModal}
        message={<>
        <div className='font-medium text-[#514D4C]'>Missing STPFC Routes</div>
        <br />
        {showMissingStpfcRoutes.routesMessge
        .split(",")
        .map((route, index) => (
        <div key={index} className='text-lightGray font-medium' >{route.trim()}</div>
        ))}
        </>}
        onClose={() => {
          setShowMissingStpfcRoutes((prev) => ({...prev, openModal: false}))
        }}
      />
      <div
      className={`w-full  smAndMd:border-b-none smAndMd:border-t smAndMd:border-r rounded-md  lg:pt-4 lg:pr-4 lg:pl-2
        ${
          !isHospitalSurveyEnable ? (isSFC
            ? 'smAndMd:border-l-4  smAndMd:border-red-700'
            : isModify
              ? 'smAndMd:border-l-4  smAndMd:border-yellow-500'
              : 'smAndMd:border-l-1') : (isHospitalSurveyEnable && routeNotFound ? "smAndMd:border-l-4  smAndMd:border-red-700" : isHospitalSurveyEnable && routesChanged ? "smAndMd:border-l-4  smAndMd:border-yellow-500" : null)
        }
            smAndMd:p-4 lg:cursor-pointer`}
      key={id}
      onClick={isHoliday ? null : () => handlerClicked(item)}
    >
      <div
        className={`w-full ${
          isEpanded
            ? 'lg:border-b-none lg:border-t lg:border-l lg:border-r rounded-t-md border-line-color'
            : 'lg:rounded-md lg:border lg:border-line-color'
        }
            ${
              isHospitalSurveyEnable
              && status === 'Reject'
                ? 'bg-[#D56AC726]'
                : !isHospitalSurveyEnable ? (isSFC
                  ? 'lg:border-l-4 lg:border-red-700'
                  : isModify
                    ? 'lg:border-l-4 lg:border-yellow-500'
                    : 'lg:border-l-1') :  isHospitalSurveyEnable && routeNotFound ? "lg:border-l-4 lg:border-red-700" : isHospitalSurveyEnable && routesChanged  ? "lg:border-l-4 lg:border-yellow-500" : null
            }
            lg:p-4 lg:cursor-pointer
          `}
      >
        <div className="block lg:hidden">
{/* {isHospitalSurveyEnable || true ? (
            <div className="px-8">
              <img
                src={greaterThanIcon}
                alt="show"
                width={24}
                height={24}
                onClick={(e) => {
                  e.stopPropagation();
                  setShowAccordian((prev) => prev === item?.expenseDetailId ? null : item?.expenseDetailId);
                }}
                className={`${showAccordian === item?.expenseDetailId ? "rotate-90" : "" }`}
              />
            </div>
          ) : null} */}

          <div className='text-lightGray font-medium'>{id + 1}</div>


          <div className="w-full flex justify-between items-center">
            <div className="flex items-center gap-4">
              {getTransportTypeIcons(modeOfTransport)}
              <span className="text-lightGray text-baseXSm font-medium">
                {modeOfTransport}
              </span>
              <span className="text-lightGray text-baseXSm font-medium">
                {category}
              </span>
            </div>
            <p className="text-primary text-baseXSm font-semibold">
              {status || ''}
            </p>
          </div>

          <div className="w-full flex justify-between items-center mt-2">
            <div className="flex items-center gap-4">
              <p
                className="text-baseMd text-primary-black"
                style={{ minWidth: '100px' }}
              >
                {fromCity?.length > 10
                  ? fromCity.slice(0, 10) + '...'
                  : fromCity}
              </p>
              <div className="flex items-center justify-center">
                <img src={swapIcon} alt="swap icon" className="h-5 w-5" />
              </div>
              <p
                className="text-baseMd text-primary-black"
                style={{ minWidth: '100px' }}
              >
                {toCity?.length > 10 ? toCity.slice(0, 10) + '...' : toCity}
              </p>
            </div>
            {isHospitalSurveyEnable ? (location?.pathname !== '/my-expense-details' ? <p className="text-base font-medium">₹ {finalTotal}</p> : null) : <p>{total}</p>}
          </div>

          <div className="w-full flex justify-between items-center mt-2">
            <p className="text-lightGray text-baseSm font-medium">
              {isHospitalSurveyEnable ? (
                <p className="text-lightGray text-[11px] font-medium">
                  {activityCode} {(activityCode === "MT" || activityCode === "TR") && meetingType ? `(${meetingType})` : null}
                </p>
              ) : (
                <p className="text-lightGray text-[11px] font-medium">
                  {isModifyRoute != null
                    ? activityCode || category_Entered
                    : activityCode || categoryName}
                </p>
              )}
            </p>
            <p style={{ color: '#2FC23D' }} className="text-baseSm font-medium">
              {formatDate(activityDate)}
            </p>
          </div>

          {/* {isHospitalSurveyEnable || true ? (
            <div>
              <img
                src={editIconPrimary}
                alt="show"
                width={18}
                height={18}
                onClick={(e) => {
                  e.stopPropagation();
                  setShowAccordian((prev) => !prev);
                }}
              />
            </div>
          ) : null} */}
        </div>

        {/* Desktop view */}
        <div
          className={`hidden lg:grid  lg:grid-cols-9 lg:items-center lg:gap-2 `}
        >

          {/* {isHospitalSurveyEnable || true ? (
            <div className="px-8">
              <img
                src={greaterThanIcon}
                alt="show"
                width={24}
                height={24}
                onClick={(e) => {
                  e.stopPropagation();
                  setShowAccordian((prev) => prev === item?.expenseDetailId ? null : item?.expenseDetailId);
                }}
                className={`${showAccordian === item?.expenseDetailId ? "rotate-90" : "" }`}
              />
            </div>
          ) : null} */}
          <div className='text-lightGray  font-medium'>{id + 1}</div>

          <div className="lg:text-center lg:col-span-1">
            <p className="text-[11px] font-medium" style={{ color: '#2FC23D' }}>
              {formatDate(activityDate)}
            </p>
          </div>

          <div className="p-1 -pl-7 lg:flex lg:items-center lg:gap-2 lg:col-span-1">
            <p className="flex flex-row items-center gap-2">
              {getTransportTypeIcons(modeOfTransport)}
              <span className="text-lightGray text-baseSm font-medium">
                {modeOfTransport}
              </span>
              <span className="text-lightGray text-[11px] font-medium">
                {category}
              </span>
            </p>
          </div>
          <div className="lg:text-center lg:col-span-1">
            {isHospitalSurveyEnable  ? (
              <p className="text-lightGray text-[11px] font-medium">
                {activityCode} {(activityCode === "MT" || activityCode === "TR") && meetingType ? `(${meetingType})` : null}
              </p>
            ) : (
              <p className="text-lightGray text-[11px] font-medium">
                {isModifyRoute != null
                  ? activityCode || category_Entered
                  : activityCode || categoryName}
              </p>
            )}
          </div>

          <div className="flex pl-3 flex-wrap ml-2 items-center lg:justify-center lg:col-span-1">
            <p
              className="text-baseMd text-primary-black "
              style={{ minWidth: '100px' }}
            >
              {fromCity?.length > 10 ? fromCity.slice(0, 10) + '..' : fromCity}
            </p>
          </div>

          <div className="flex flex-wrap -ml-6 items-center lg:justify-center lg:col-span-1">
            {/* <img src={swapIcon} alt="swap icon" className="h-5 w-5" /> */}
            <ViceversaArrow color="#79747E" />
          </div>

          <div className="flex flex-wrap pr-2 -ml-9 items-center lg:justify-center lg:col-span-1">
            <p
              className="text-baseMd text-primary-black pl-3 "
              style={{ minWidth: '100px' }}
            >
              {toCity?.length > 10 ? toCity.slice(0, 10) + '..' : toCity}
            </p>
          </div>

          <div className="lg:text-center -ml-2 lg:col-span-1 scroll-pl-6">
            <p className="text-primary text-[11px] font-semibold">
              {status || 'unsubmitted'}
            </p>
          </div>

          {/* <div className="lg:text-center lg:col-span-1">
            <p className="text-[11px] font-medium" style={{ color: '#2FC23D' }}>
              {formatDate(activityDate)}
            </p>
          </div> */}

          <div className="lg:text-right lg:col-span-1">
            {isHospitalSurveyEnable ? (location?.pathname !== '/my-expense-details' ? <p className="text-base font-medium">₹ {finalTotal}</p> : null) : <p>{total}</p>}
          </div>

          {/* {isHospitalSurveyEnable || true ? (
            <div className="px-8">
              <img
                src={editIconPrimary}
                alt="show"
                width={24}
                height={24}
                onClick={(e) => {
                  e.stopPropagation();
                  setShowAccordian((prev) => !prev);
                }}
              />
            </div>
          ) : null} */}
        </div>
      </div>

      {showAccordian || true ? (
        <div className={`lg:flex lg:flex-row lg:border-b-[1px]  lg:border-l-[1px]  lg:border-r-[1px] ${ isHospitalSurveyEnable && routeNotFound ? "lg:border-l-4 lg:border-red-700" : isHospitalSurveyEnable && routesChanged  ? "lg:border-l-4 lg:border-yellow-500" : "lg:border-line-color" } rounded-b-md   lg:cursor-pointer`}>
          {[
            { label: 'Way', value: wayEntered },
            { label: 'Distance', value: distance || distanceEntered || 0 },
            { label: 'Fare', value: fare || fareEntered || 0 },
            { label: 'Allowance', value: allowancesEntered },
            { label: 'Other Expense Total', value: otherExpenseTotal },
            { label: 'Admin Remarks', value: adminRemarks },
            { label: 'Manager Remarks', value: managerRemarks }
          ].map((item, index) => {
            const isBorderNeeded =
              index < 6 ? 'md:border-r-[1.5px] lg:border-[#B3B3B3]' : '';
            return (
              <div key={index} className={expendetHeaderCSS}>
                <div className={expendedSemiHeaderCSS}>
                  <p
                    className={`smAndMd:grow smAndMd:border-r-2 smAndMd:border-white lg:grow ${isBorderNeeded} font-medium text-[#514D4C]`}
                  >
                    {item.label}
                  </p>
                </div>
                <div className={expenedParagraphSecondCSS}>{item.value}</div>
              </div>
            );
          })}
        </div>
      ) : null}

      {isEpanded && false && <div className={dividerClass}></div>}
      {isEpanded && expenseDataShow && false && (
        <div className="lg:flex lg:flex-row lg:border-b-[1px]  lg:border-l-[1px]  lg:border-r-[1px] lg:border-line-color rounded-b-md   lg:cursor-pointer">
          {[
            { label: 'Category', value: activityCode || categoryName },
            { label: 'Travel Mode', value: modeOfTransport },
            { label: 'Distance', value: distance },
            { label: 'Fare', value: fare },
          ].map((item, index) => {
            const isBorderNeeded =
              index < 3 ? 'md:border-r-[1.5px] lg:border-[#B3B3B3]' : '';
            return (
              <div key={index} className={expendetHeaderCSS}>
                <div className={expendedSemiHeaderCSS}>
                  <p
                    className={`smAndMd:grow smAndMd:border-r-2 smAndMd:border-white lg:grow ${isBorderNeeded}`}
                  >
                    {item.label}
                  </p>
                </div>
                <div className={expenedParagraphSecondCSS}>{item.value}</div>
              </div>
            );
          })}
        </div>
      )}
    </div></>
  );
};

export default MyExpenseList;
